import css from "PFApp/booking/parts/overview/detail_view/detail_view.module.scss";
import { useMetadata } from "PFApp/components/activity_commons/use_metadata";
import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { Activity } from "PFTypes";
import { useTranslation } from "react-i18next";

import { Label } from "../parts/label";

const ROLE_SIDE_PANEL_SECTION_KEY = "role_side_panel";

type CustomFieldsProps = {
  activity: Activity;
};

export const CustomFields = ({ activity }: CustomFieldsProps) => {
  const { t } = useTranslation(["bookingModule", "translation"]);

  const metadata = useMetadata({ activity, visibilitySectionKey: ROLE_SIDE_PANEL_SECTION_KEY });

  const filteredMetadata = metadata.filter(({ name }) => !["availability", "skills"].includes(name));

  return (
    <span className={css.detailsRole}>
      <div className={css.item}>
        <Label text={t("translation:privacy")} />
        <Inline alignItems="center" gap="spacingSm">
          <Typography variant="bodyBold">
            {t(activity.private ? "translation:privatePrivacy" : "translation:publicPrivacy")}
          </Typography>
          {activity.private && (
            <Tooltip
              content={t("bookingModule:details.privacyTooltipText")}
              triggerContainerProps={{ className: css.alignCenter }}
            >
              <Icon name="info" size="sm" />
            </Tooltip>
          )}
        </Inline>
      </div>
      {filteredMetadata.map(({ title, text }) => (
        <div key={title} className={css.item}>
          <Label text={title} />
          <Typography variant="bodyBold">{text}</Typography>
        </div>
      ))}
    </span>
  );
};
